import { MembershipStatus } from "../Enums/FirmEnum";

/** Canonical membership status labels (same as /ManageFirm list). */
export const MEMBERSHIP_STATUS = MembershipStatus;

export type MembershipStatusLabel =
  (typeof MembershipStatus)[keyof typeof MembershipStatus];

const CANONICAL_STATUS_LABELS = new Set<string>(
  Object.values(MembershipStatus),
);

const LEGACY_ALIASES: Record<string, MembershipStatusLabel> = {
  TemporaryWithdrawn: MembershipStatus.TemporaryWithdrawn,
  "Temporarily Withdrawn": MembershipStatus.TemporaryWithdrawn,
};

export function normalizeMembershipStatus(
  value?: string | null,
): MembershipStatusLabel | "" {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) {
    return "";
  }
  const normalized = LEGACY_ALIASES[trimmed] ?? trimmed;
  if (CANONICAL_STATUS_LABELS.has(normalized)) {
    return normalized as MembershipStatusLabel;
  }
  return normalized as MembershipStatusLabel;
}

export function getMembershipStatusDisplayColor(
  status?: string | null,
): string {
  switch (normalizeMembershipStatus(status)) {
    case MembershipStatus.Member:
      return "#2AA042";
    case MembershipStatus.TemporaryWithdrawn:
      return "#C6A80D";
    case MembershipStatus.Withdrawn:
      return "#FF6109";
    default:
      return "";
  }
}

export function getMembershipStatusTextClass(
  status?: string | null,
): string {
  const normalized = normalizeMembershipStatus(status);
  if (normalized === MembershipStatus.Member) {
    return "text-feedback-success-Default";
  }
  if (normalized === MembershipStatus.Withdrawn) {
    return "text-feedback-error";
  }
  if (normalized === MembershipStatus.TemporaryWithdrawn) {
    return "text-[#C6A80D]";
  }
  return "text-black";
}
